module.exports = __webpack_public_path__ + "e3ca304e17756b2ac262479591673a44.png";